import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { intl } from './../../../core/globalIntl';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import * as Render from './../../../lib/render';
import * as Validator from './../../../lib/validate';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import {QrReader} from 'react-qr-reader';
import readQRcss from "./readQR.module.css";

import setting from './../../../config/setting.js';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  container: {
    width: '100%',
    padding: '0 12px 0 12px',
  },
  container2: {
    width: '100%',
    padding: '0 12px 0 0',
  },
  container3: {
    padding: '0 0 0 12px',
  },
  header: {
    backgroundColor: '#5dabdb',
    color: '#ffffff',
    textAlign: 'center',
    padding: '20px'
  },
  closeButton: {
    position: 'absolute',
    right: '0px',
    top: '0px',
    color: '#a5a5a5',
  },
  rows: {
    width: '100%',
    padding: '20px 12px 20px 12px',
    border: "1px solid rgba(224, 224, 224, 1)",
    backgroundColor: '#deebf7', 
  },
  fs80:{
    fontSize: 25,
    textAlign: 'center',
  },
  explanation:{
    fontSize: 25,
    textAlign: 'center',
    whiteSpace: "pre-line",
    padding: '20px 10px 10px 10px'
  },
  text: {
    fontSize: '10pt',
  },
  text2:{
    fontSize: 20,
    textAlign: 'center',
  },
  text3:{
  	fontWeight : "bold",
  },
  text4:{
    fontSize: 13,
    textAlign: 'center',
    fontWeight : "bold",
  },
  setaiButton:{
    minWidth: 64,
    lineHeight: "42.25px",
    borderRadius: 4,
    border: "solid 2px 	#696969",
    padding: "0 16px",
    color: "#000000",
    background: "transparent"
  },
  setaiInfoButton:{
    minWidth: 0,
    lineHeight: "0px",
    border: 0,
    color: "transparent",
    background: "transparent",
    display: "none"
  },
  textWidth80: {
    maxWidth: 80,
    fontSize: '10pt',
  },
  textWidth100: {
    maxWidth: 100,
    fontSize: '10pt',
  },
  textWidth230: {
    maxWidth: 230,
    fontSize: '10pt',
  },
  selectMultiple: {
    width: '100%',
  },
  title: {
    minWidth: '100px',
    maxWidth: '140px',
  },
  control: {
    textAlign: 'left',
    padding: '20px',
  },
  textField: {
    maxWidth: 300,
    textAlign: 'center',
  },
  textField2: {
    maxWidth: 300,
    textAlign: 'center',
    padding: '0 12px 0 12px',
  },
  checkBox: {
    marginLeft: 35,
    padding: '20px 0 20px 0',
  },
  textCenter: {
    textAlign: 'center',
    padding: '20px'
  },
  textCenter2: {
    textAlign: 'center',
    padding: '20px 0px 20px 0px'
  },
  textLeft: {
    textAlign: 'left',
    padding: '20px'
  },
  textRight: {
    textAlign: 'right',
    padding: '0px'
  },  
  textUnderLine: {
    fontWeight : "bold",
    borderBottom: "solid 1px",
  },
  textTransparent:{
    color: 'transparent'
  },
  modalRow: {
    width: '100%',
    padding: '0px 5px 20px 5px',
  },

  modalRow2: {
    width: '100%',
    padding: '0px 0px 20px 0px',
  },
  textField3: {
    maxWidth: 150,
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    height: "40px",
    color: 'blue',
    fontSize: 15,
    textAlign: 'center',
    lineheight: 2,
  },
  textField4: {
    maxWidth: 150,
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    height: "40px",
    fontSize: 15,
    textAlign: 'center',
    lineheight: 2,
    cursor: 'pointer',
    color: 'blue',
    caretColor: 'transparent',
    textDecoration: 'underline',
    display:'none',
    '&:disabled': {
      textDecoration: 'none',
    },
  },
  cursor: {
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underline',
  },
  shadow:{
    boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'
  },
  fontBlue: {
    color: '#0000FF',
  }
});

class Infoadd extends React.Component {
  state = {
    length: 1,
    getCount: 0,
    qrResult: '',
    isModalShow: false,
    isKojinDialog: false,
    isSetaiDialog: false,
    onClickflg: '',
    onClickRow: 0,
    infraDamage:[],
    cooperation:[]
  }

  // 登録済情報読込処理
  doSearch = async(KojinNum, Uuid) => {
    console.log("KojinNum", KojinNum);
    console.log("Uuid", Uuid);

    let check = "";

    //QRコードで読み込んだ個人番号をもとに世帯番号を取得
    let resKojin = await this.props.doGetKojin(KojinNum, Uuid, '', 'K');
    check = this.props.doCheckResponse(resKojin);
    if (!check) { return; }
    
    //世帯番号の登録がない場合
    if (resKojin.data.totalCount == 0) {
      alert("登録されていない世帯主もしくは同世帯の個人用QRコードです\nご確認いただき、もう一度個人用QRコード読取をしてください");
      this.getKojinNumber();

      //steteをクリア
      this.setState({length: 1});
      this.setState({getCount: 0});
      
      //storeのsetaiInfoとkojinInfoをクリア
      this.props.doResetSetaiInfo();
      this.props.doResetKojinInfoList();
      this.props.doSetKojinInfo(0);
      
      //一覧クリア
      document.getElementById("personalNumber_" + (1)).setAttribute('value', '');
      document.getElementById("name_" + (1)).setAttribute('value', '');
      this.props.change("representative_" + (1), [] );
      return;
    }

    //取得した世帯番号をもとに対象の住民を取得
    let resKojinList = await this.props.doGetKojin('', '', resKojin.data.records[0].householdNumber.value, 'S');

    check = this.props.doCheckResponse(resKojinList);
    if (!check) { return; }

    //取得した件数をセット
    this.setState({length: resKojinList.data.records.length});
    this.setState({getCount: resKojinList.data.records.length});

    //storeのsetaiInfoとkojinInfoをクリア
    this.props.doResetSetaiInfo();
    this.props.doResetKojinInfoList();

    //1件ずつstoreにデータを設定
    for(let i=0; i < resKojinList.data.records.length; i++){
      console.log(resKojinList.data.records[i]);
      this.props.doSetRegisteredKojinInfoList(i+1,resKojinList.data.records[i]);
    }
    
    //データの並び替え
    this.doSortKojinInfo(this.props.kojinInfo);
    
    //各項目に取得した値を設定
    for(let i=0; i < this.props.kojinInfo.length; i++){
      
      //氏名を取得
      let personalName = this.doGetPersonalName(this.props.kojinInfo[i]);
      console.log(this.props.kojinInfo[i].personalNumber);
      console.log(personalName);
      
      this.props.change("personalNumber_" + (i+1), this.props.kojinInfo[i].personalNumber );
      this.props.change("name_" + (i+1), personalName );
      if ( this.props.kojinInfo[i].representativeFlag == "1" ) {
        this.props.change("representative_" + (i+1), ["1"] );
      } else {
        this.props.change("representative_" + (i+1), [] );
      }
      document.getElementById("personalNumber_" + (i+1)).setAttribute('value', this.props.kojinInfo[i].personalNumber);
      document.getElementById("name_" + (i+1)).setAttribute('value', personalName);
      document.getElementById("personalNumber_" + (i+1)).setAttribute('style','display:flex');
    }

  };

  showMessage = () => {
    let param = {
      type:'close',
      title: '',
      message: 'dialog.click.btnGet',
      action: '',
    };
    this.props.doOpenDialogOperation(param);
    return;
  };

  //登録ボタン押下
  doSetKojin = async() => {
    
    //登録データがあるかチェック
    let registerCnt = this.props.kojinInfo.filter(v => v.outFlag === "0").length;
    
    //登録データがある場合
    if (registerCnt !== 0){
      console.log('----登録処理----');
      
      //データチェック
      let res = this.doCheckData();
      console.log(res);
      if (!res) { return; }
      
      //データ登録
      let result = await this.props.doSetKojin( this.state.length, this.state.getCount);
      let check = this.props.doCheckResponse(result, 'dialog.status429.errorElse.duplicatePersonalNumber');
      if (!check) { return; }
      
      //データの並び替え
      this.doSortKojinInfo(this.props.kojinInfo);
    }    
    //完了画面に移動
    this.props.history.push('./insertcomplete');
  };

  // 登録データのチェック
  doCheckData = () => {
    console.log("代表者の数：")
    //登録データがあるかチェック
    let registerCnt = this.props.kojinInfo.filter(v => v.personalNumber === "" && v.outFlag === "0").length;

    if (registerCnt > 0 ){
      let param = {
        type:'close',
        title: '',
        message: 'dialog.error.noRegisterData',
        action: '',
      };
      this.props.doOpenDialogOperation(param);
      return false; 
    }
    
    //代表者のチェック
    let representativeCnt = 0;
    let representativeIdx = 0;
    for(let i=1; i < this.state.length + 1; i++){
      if ( "representative_" + i  in this.props.values ) { 
        if ( this.props.values["representative_" + i][0] == "1" ) {
          representativeCnt += 1;
          representativeIdx = i
        }
      }
    }
    console.log("代表者の数："+representativeCnt)
    // チェック判定
    if ( representativeCnt !== 1 ){
      let param = {
        type:'close',
        title: '',
        message: 'dialog.error.representative',
        action: '',
      };
      this.props.doOpenDialogOperation(param);
      return false; 
    }
    
    // 代表者フラグを設定
    let values = this.props.kojinInfo.find(v => v.idx === representativeIdx);
    console.log('代表者データ');
    console.log(values);
    values.representativeFlag = "1";
  
    
    //同じ個人番号が登録されていないかチェック
    let numberCnt = this.props.kojinInfo.filter((x,y,z)=>z.slice(0,z.length).filter(w=>w.personalNumber==x.personalNumber).length>=2);
    console.log(numberCnt);
    
    if (numberCnt.length !== 0){
      let param = {
        type:'close',
        title: '',
        message: 'dialog.error.duplicatePersonalNumber',
        action: '',
      };
      this.props.doOpenDialogOperation(param);
      return false; 
    }
    
    // 個人情報（氏名）が入力されているかチェック
    for(var i=0; i<=this.props.kojinInfo.length-1; i++){
      console.log(this.props.kojinInfo[i].personalName);
      console.log(this.props.kojinInfo[i].personalHira);
      console.log(this.props.kojinInfo[i].personalKana);
      if (this.props.kojinInfo[i].personalName === '' &&
          this.props.kojinInfo[i].personalHira === '' &&
          this.props.kojinInfo[i].personalKana === '' )  {
        
        let message = intl.formatMessage({ id: 'dialog.error.requiredPersonalName' }, { values: i+1});
        let param = {
          type:'close',
          title: '',
          message: message,
          action: '',
          notFormat:true,
        };
        this.props.doOpenDialogOperation(param);
        return false; 
      }
    }
    
    return true;
  };
  
  // 表示氏名の取得
  doGetPersonalName = (values) => {
    if (values.personalName !== ''){
      return values.personalName;
    } else if (values.personalHira !== ''){
      return values.personalHira;
    } else {
      return values.personalKana;
    }
  };
  
  // 個人データ並び替え
  doSortKojinInfo = (list) => {
    let sortList = list;
    
    //個人番号の昇順
    sortList.sort((a, b) => {
        if(a.personalNumber > b.personalNumber) return 1;
        if(a.personalNumber < b.personalNumber) return -1;
        return 0;
    });
        
    //代表者は一番上
    sortList.sort((a, b) => {
        if(a.representativeFlag > b.representativeFlag) return -1;
        if(a.representativeFlag < b.representativeFlag) return 1;
        return 0;
    });
    console.log(sortList);
  }

  //個人情報モーダル表示
  doModal = (idx) => {
    // 個人番号がない場合は表示しない
    if (document.getElementById("personalNumber_" + idx).value === '')  { return; }
    
    // storeの個人データ取得
    let values = this.props.kojinInfo.find(v => v.idx === idx);
    console.log(values);
    
    // storeに個人データセット
    this.props.doSetKojinInfoDetail(values);
    //個人情報モーダル画面初期化
    this.doSetKojinModalValues(values);
    //フォーカスをクリア
    this.props.untouch('Infoadd', 'PersonalNameTextFiled');
    //個人情報モーダル画面表示
    this.setState({isKojinDialog:true});
  }
  
  // 個人情報モーダル設定
  doSetKojinModalValues = (values) => {
    
    var mappingList = {
      'PersonalNameTextFiled': 'personalName',
      'PersonalHiraTextFiled': 'personalHira',
      'PersonalKanaTextFiled': 'personalKana',
      'GenderSelectBox': 'gender',
      'BirthDateYearSelectBox': 'birthDateYear',
      'BirthDateMonthSelectBox': 'birthDateMonth',
      'BirthDateDaySelectBox': 'birthDateDay',
      'AgeTextFiled': 'age',
      'TelephoneNumberTextFiled': 'telephoneNumber',
      'RelationshipTextFiled': 'relationship',
      'NationalitySelectBox': 'nationality',
      'OtherNationalityTextFiled': 'otherNationality',
      'LanguageTextFiled': 'language',
      'EvacuationFormSelectBox': 'evacuationForm',
      'OtherEvacuationFormTextFiled': 'otherEvacuationForm',
      'PlaceSelectBox': 'place',
      'OtherPlaceTextFiled': 'otherPlace',
      'FoodsSelectBox': 'foods',
      'OtherFoodsTextFiled': 'otherFoods',
      'DiseaseTextFiled': 'disease',
      'InjuryTextFiled': 'injury',
      'ShoniIryoSelectBox': 'shoniIryo',
      'JinkoTosekiSelectBox': 'jinkoToseki',
      'SansoRyohoSelectBox': 'sansoRyoho',
      'FujinkaIryoSelectBox': 'fujinkaIryo',
      'SeishinIryoSelectBox': 'seishinIryo',
      'FeverCoughSelectBox': 'feverCough',
      'KaigoTextFiled': 'kaigo',
      'DeficiencySelectBox': 'deficiency',
      'RiskSelectBox': 'risk',
      'BloodTypeSelectBox': 'bloodType',
      'MedicineSelectBox': 'medicine',
      'MedicineTextFiled': 'medicineName',
      'AllergyTextFiled': 'allergy',
      'DisabledTextFiled': 'disabled',
      'IryokikiSelectBox': 'iryokiki',
      'PregnancySelectBox': 'pregnancy',
      'ChildSelectBox': 'child',
      'RequestTextFiled': 'request',
      'OtherCooperationTextFiled': 'otherCooperation',
      'FreeTextFiled': 'free',
      'InformationSelectBox': 'information',
      'DisclosureSelectBox': 'disclosure',
      'Spare1TextFiled': 'spare1',
      'Spare2TextFiled': 'spare2',
      'Spare3TextFiled': 'spare3',
      'Spare4TextFiled': 'spare4',
      'Spare5TextFiled': 'spare5'
    };
    
    // 画面に個人情報を設定する
    for(var key in mappingList) {
      let value = values[mappingList[key]];
      this.props.change(key, value === '' ? '' : value);
    }
    
    this.props.change('CooperationSelectBox', values.cooperation.length === 0 ? 
      this.setState({cooperation:[]}) : this.setState({cooperation:values.cooperation}));
  }
  
  //個人情報モーダルクローズ
  handleClose = () => {
    this.setState({isKojinDialog: false});
  }
  
  //個人情報モーダル　登録ボタン押下
  doSetKojinInfolist = async() => {
    
    //storeの個人情報一覧を更新
    this.props.doSetKojinInfoList(this.state.cooperation);
    
    let idx = this.props.kojinInfoDetail.idx;
    let values = this.props.kojinInfo.find(v => v.idx === idx);
    console.log(idx);
    console.log(values)
    
    //表示氏名をセット
    document.getElementById("name_" + idx).setAttribute('value', this.doGetPersonalName(values));
    
    //個人情報モーダルを閉じる
    this.setState({isKojinDialog: false});
  };

  //登録済情報読込ボタン
  getKojinNumber = () => {
    this.setState({onClickflg: "1"});
    this.setState({
      isModalShow: true,
      qrResult: ''
    });
    

  }
  
  // 個人番号読み取りボタン
  getKojinNumberRead = (idx) => {
    console.log("idx", idx);
    this.setState({onClickflg: "2"});
    this.setState({onClickRow: idx});
    this.setState({
      isModalShow: true,
      qrResult: ''
    });
  }
  
  // QRコード読み込みクローズ
  closeModal = () => {
    this.setState({
      isModalShow: false,
      onClickflg: '',
      qrResult: ''
    });
  }
  
  // QRコード読み込み表示
  handleScan = (result, error) => {

    if (!!result) {
      console.log(result?.text);
      this.setState({
        qrResult: result?.text,
        isModalShow: false
      });
      
      let param = result?.text.split('___');
      if( this.state.onClickflg === "1" ){
        this.doSearch(param[0], param[1]);
        
        
      }else{
        console.log("personalNumber_" + this.state.onClickRow);
        this.props.change("personalNumber_" + this.state.onClickRow, param[0] );
        this.props.doSetKojinNumber(this.state.onClickRow, param[0] ,param[1])
        document.getElementById("personalNumber_" + this.state.onClickRow).setAttribute('value',param[0]);
        document.getElementById("name_" + this.state.onClickRow).setAttribute('value','');
        document.getElementById("personalNumber_" + this.state.onClickRow).setAttribute('style','display:flex');
      }
    }
  }

  //世帯情報モーダル表示
  doSetaiModal = () => {

    //世帯情報モーダル画面初期化
    this.doSetSetaiModalValues(this.props.setaiInfo);
    // 世帯情報モーダル画面表示
    this.setState({isSetaiDialog:true});
  }
  
  // 世帯情報モーダル設定
  doSetSetaiModalValues = (values) => {
    
    var mappingList = {
      'DistrictNameTextFiled': 'districtName',
      'ChonaikaiNameTextFiled': 'chonaikaiName',
      'JichikaiNameTextFiled': 'jichikaiName',
      'AddressTextFiled': 'address',
      'PersonalNameECTextFiled': 'personalNameEC',
      'AddressECTextFiled': 'addressEC',
      'NumberECTextFiled': 'numberEC',
      'RelationshipECTextFiled': 'relationshipEC',
      'RepresentativeNameTextFiled': 'representativeName',
      'RepresentativeHiraTextFiled': 'representativeHira',
      'RepresentativeKanaTextFiled': 'representativeKana',
      'EntryNameTextFiled': 'entryName',
      'EntryHiraTextFiled': 'entryHira',
      'EntryKanaTextFiled': 'entryKana',
      'HomePhoneNumberTextFiled': 'homePhoneNumber',
      'FaxNumberTextFiled': 'faxNumber',
      'EvacuationTypeSelectBox': 'evacuationType',
      'TransportationSelectBox': 'transportation',
      'OtherTransportationTextFiled': 'otherTransportation',
      'CarsTextFiled': 'cars',
      'CarModelTextFiled': 'carModel',
      'CarColorTextFiled': 'carColor',
      'CarNumberPlateTextFiled': 'carNumberPlate',
      'ParkingTextFiled': 'parking',
      'PetSelectBox': 'pet',
      'PetStateSelectBox': 'petState',
      'HouseDamageSelectBox': 'houseDamage',
      'OtherDamageTextFiled': 'otherDamage',
      'CitizenSelectBox': 'citizen',
      'Spare1RTextFiled': 'spare1R',
      'Spare2RTextFiled': 'spare2R',
      'Spare3RTextFiled': 'spare3R',
      'Spare4RTextFiled': 'spare4R',
      'Spare5RTextFiled': 'spare5R'
    };
    
    // 画面に世帯情報を設定する
    for(var key in mappingList) {
      let value = values[mappingList[key]];
      this.props.change(key, value === '' ? '' : value);
    }
    
    this.props.change('InfraDamageSelectBox', ((values.infraDamage == undefined) || (values.infraDamage.length === 0)) ? 
      this.setState({infraDamage:[]}) : this.setState({infraDamage:values.infraDamage}));

  }
  
  //世帯情報モーダルクローズ
  handleSetaiClose = () => {
    this.setState({isSetaiDialog: false});
  }
  
  //世帯情報モーダル　登録ボタン押下
  doSetSetaiInfo = async() => {
    let options = {era: 'long'};
    console.log(new Intl.DateTimeFormat('ja-JP-u-ca-japanese',{year:'numeric', month: '2-digit'}).format(new Date()));
    console.log(new Intl.DateTimeFormat('ja-JP-u-ca-japanese', options).format(new Date()));
    console.log("Modal", "test");
    
    this.props.doSetSetaiInfo(this.state.infraDamage);
    this.setState({isSetaiDialog: false});
  };
  
  // 行追加ボタンクリック
  addRow = () => {
    this.setState({length: this.state.length + 1});
    console.log(this.state.length)
    console.log(this.state.length + 1)
    this.props.doSetKojinInfo(this.state.length);
  }
  
  // 行削除ボタンクリック
  delRow = () => {
    if ( this.state.getCount === this.state.length ){
      return;
    }
    if(this.state.length!=1){
      //項目リセット
      this.props.change("personalNumber_" + this.state.length, "" );
      this.props.change("representative_" + this.state.length, "" );

      this.setState({length: this.state.length - 1});
      console.log(this.state.length)
      this.props.doDeleteKojinInfo(this.state.length - 1);
    }else{
      let param = {
        type:'close',
        title: '',
        message: 'dialog.error.notDeleteRow',
        action: '',
      };
      this.props.doOpenDialogOperation(param);
      return;
    }
  }

  // 行追加処理
  createRow = (idx) => {
    let classes = this.props.classes;
    let keys = {
      dataRow: "dataRow_"+idx,
      name: "name_"+idx,
      representative : "representative_"+idx,
      householdNumber : "householdNumber_" + idx,
      personalNumber : "personalNumber_" + idx,
    };
    
    return (
      <Grid container className={classes.rows} id={keys.dataRow} key={idx}>
        <CssBaseline />
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Grid className={classes.textCenter2}>
              <Button
                id="modalShow"
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={() => {this.getKojinNumberRead(idx)}}
                size="small"
                disabled={this.state.getCount < idx ? false : true}
              >  
                <span>読取</span>
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={6} className={classes.textCenter}>
            <span>
              <span>
                <input
                  type="text"
                  name={keys.personalNumber}
                  id={keys.personalNumber}
                  className={classes.textField4} 
                  disabled={this.state.getCount < idx ? false : true}
                  onClick={() => {this.doModal(idx)}}
                  />
              </span>
              <span>
                <input
                  type="text" 
                  name={keys.name} 
                  id={keys.name} 
                  className={classes.textField3} 
                  disabled={true}
                />
              </span>
            </span>
          </Grid>
          
        
          
          <Grid item xs={3} className={classes.textCenter2}>
            <Field
              id={keys.representative}
              name={keys.representative}
              component={Render.checkBox}
              className={classes.checkBox}
              disabled={this.state.getCount < idx ? false : true}
              options={[
                {key: "1"}
              ]}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  }
  
  render() {
    const { classes, handleSubmit } = this.props;
    
    let rows  = [];
    for(var i=1; i<=this.state.length; i++){
      rows.push(this.createRow(i));
    }
    
    return (
      <div className={classes.root}>
        <CssBaseline />
        <Grid container className={classes.container} spacing={2}>
          <Grid item xs={12}></Grid>
          <Grid item xs={12} sm={12} className={classes.explanation}>
            <span className={classes.fontBlue}>
              避難所への入所受付
            </span>
            <span>
              を行います
            </span>
          </Grid>
          <Grid item xs={12} sm={12} className={classes.text2}>
            <span>
              避難所名：{this.props.shelterName}
            </span>
          </Grid>
          <Grid item xs={12} sm={12} className={classes.textLeft}>
            <span>
              以下の手順に従ってください
            </span>
          </Grid>


          
          <Grid item xs={12} sm={12}></Grid>
          {
            this.props.entryKubun == 1 ||(this.props.entryKubun == 2 && this.state.getCount != 0 ) ? 
			""
          :
            <div>
              <Grid item xs={12} sm={12}>
                <Button
                  id="btnGet"
                  variant="contained"
                  color="primary"
                  onClick={this.getKojinNumber}
                  className={classes.setaiInfoButton}
                  size="large"
                > 
                </Button>
              </Grid>
              <Grid item xs={12} sm={12}></Grid>
            </div>
            
       
          }
   
          
          
          <Grid item xs={12} sm={12}>
          {
            this.props.entryKubun == 1 ? 
            <span className={classes.textUnderLine}>
              １.個人用QRコードを読んで、世帯主、同世帯者の情報を入力してください
            </span>
          :
            ""
           }
          {
            this.props.entryKubun != 1 ? 
            <span className={classes.textUnderLine}>
              １.追加する方の個人用QRコードを読んで、情報を入力してください
            </span>
          :
            ""
           }           
          </Grid>

          <Grid item xs={12}>
            <Grid container className={classes.shadow}>
              <Grid item xs={3} className={classes.header}>
                <FormattedMessage id={'infoadd.columns.QR'}/><br/>
                <FormattedMessage id={'infoadd.columns.yomitori'}/>
              </Grid>
              <Grid item xs={6} className={classes.header}>
                <FormattedMessage id={'infoadd.columns.kojinNum'}/>
              </Grid>
              <Grid item xs={3} className={classes.header}>
                <FormattedMessage id={'infoadd.columns.representative'}/>
              </Grid>

              <Grid item xs={12} id="personalRows">
                {rows}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12}>
            <span>
              登録する同世帯者を
            </span>
          </Grid>
          <Grid item xs={12} className={classes.control}>
            <span className={classes.container3}>
              <Button
                id="btnAdd"
                variant="contained"
                color="primary"
                onClick={this.addRow}
                className={classes.button}
                size="large"
              >  
                <span>追加</span>
              </Button>
            </span>
            <span className={classes.container3}>
              <Button
                id="btnDelete"
                variant="contained"
                color="primary"
                onClick={this.delRow}
                className={classes.button}
                size="large"
              >  
                <span>削除</span>
              </Button>
            </span>
          </Grid>

          {
          	this.props.entryKubun == 1 ?
		  <div><br/>
		    <Grid item xs={12} sm={12}>
            <span className={classes.textUnderLine}>
              ２.入力が完了したら登録を押してください

            </span>
        </Grid>
        
        {
        this.props.entryKubun == 1 ? 
        <Grid item xs={12} className={classes.control}>
            <span className={classes.container3}>
              <Button
              id="btnDialg"
              variant="contained"
              onClick={this.doSetaiModal}
              className={classes.setaiButton}
              size="large"
            >  
              <span>世帯情報を修正</span>
              </Button>
            </span>
            <span className={classes.container3}>
              <Button
                id="btnPost"
                variant="contained"
                color="primary"
                className={classes.button}
                size="large"
                onClick={handleSubmit(this.doSetKojin)}
              >  
                <span>登録</span>
              </Button>
            </span>

          </Grid> 
          :
            ""
          }          
          </div>
          :
          	""
          }

          <Grid item xs={12} sm={12}></Grid>
          {
            this.props.entryKubun != 1 ? 
          <Grid item xs={12} sm={12}>
          

            <span className={classes.textUnderLine}>
              ２．登録してください
            </span>
            <Grid item xs={12} sm={12}></Grid> <br/>
            <span className={classes.container3}>
            <Button
              id="btnPost"
              variant="contained"
              color="primary"
              className={classes.button}
              size="large"
              onClick={handleSubmit(this.doSetKojin)}
            >  
              <span>登録</span>
            </Button>
            </span>
          </Grid>
          :
          ""
          }          
          
          <Grid item xs={12} sm={12} >
          {
            this.state.isModalShow ? 
              <div id="modal" className={readQRcss["modal"] +" "+readQRcss["is-show"]}> 
              {this.state.onClickflg == "1"?
                  <Button
                    id="modalClose"
                    variant="contained"
                    color="primary"
                    onClick={() => this.props.history.goBack()}
                    className={classes.button + " " + readQRcss["modal-close"]}
                    size="large">戻る</Button>
              :""
              }
              {this.state.onClickflg != "1"?
                <Button
                id="modalClose"
                variant="contained"
                color="primary"
                onClick={this.closeModal}
                className={classes.button + " " + readQRcss["modal-close"]}
                size="large">閉じる</Button>
              :""
              }
                  { this.state.onClickflg == "1" ?
                    <div className={readQRcss["modal-explanation"]}>
                      
                      <Grid item xs={12} sm={12} className={classes.text4}>入所済の同世帯の方の個人用QRコードを読み取ってください</Grid>
                    </div>
                  :""
                }
                  <div id="modalInner" className={readQRcss["modal-inner"]} ref="modalInner">
                    <QrReader
                      scanDelay={300}
                      onResult={this.handleScan}
                      videoContainerStyle={{ position: "absolute", "paddingTop": '0%', width: '100%', height: '100%' }}
                      constraints={ {facingMode: {exact: 'environment'} }}

                    />
                  </div>
                  <div id="modalBackground" className={readQRcss["modal-background"] +" "+readQRcss["is-show"]}  ></div>

              </div>
              
             : ""
          }

          </Grid>
          
          
          <Dialog
            open={this.state.isSetaiDialog}
            onClose={(event, reason) =>
                       {if (reason !== 'backdropClick') {this.handleSetaiClose()}}}
            fullWidth={true}
            maxWidth="xl"
            scroll="paper"
            aria-labelledby="scroll-dialog-title"
          >
            <React.Fragment>
              <DialogTitle>
              世帯情報を入力してください
                <IconButton className={classes.closeButton} onClick={this.handleSetaiClose}>
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                  {this.props.showHide.DistrictNameTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.districtName'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="DistrictNameTextFiled"
                          name="DistrictNameTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.ChonaikaiNameTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.chonaikaiName'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="ChonaikaiNameTextFiled"
                          name="ChonaikaiNameTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.JichikaiNameTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.jichikaiName'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="JichikaiNameTextFiled"
                          name="JichikaiNameTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.AddressTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.address'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="AddressTextFiled"
                          name="AddressTextFiled"
                          component={Render.textFieldMax100}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,100),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.PersonalNameECTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.personalNameEC'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="PersonalNameECTextFiled"
                          name="PersonalNameECTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.AddressECTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.addressEC'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="AddressECTextFiled"
                          name="AddressECTextFiled"
                          component={Render.textFieldMax100}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,100),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.NumberECTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.numberEC'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="NumberECTextFiled"
                          name="NumberECTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.RelationshipECTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.relationshipEC'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="RelationshipECTextFiled"
                          name="RelationshipECTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.RepresentativeNameTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.representativeName'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="RepresentativeNameTextFiled"
                          name="RepresentativeNameTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.RepresentativeHiraTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.representativeHira'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="RepresentativeHiraTextFiled"
                          name="RepresentativeHiraTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.RepresentativeKanaTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.representativeKana'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="RepresentativeKanaTextFiled"
                          name="RepresentativeKanaTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.EntryNameTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.entryName'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="EntryNameTextFiled"
                          name="EntryNameTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.EntryHiraTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.entryHira'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="EntryHiraTextFiled"
                          name="EntryHiraTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.EntryKanaTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.entryKana'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="EntryKanaTextFiled"
                          name="EntryKanaTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.HomePhoneNumberTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.homePhoneNumber'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="HomePhoneNumberTextFiled"
                          name="HomePhoneNumberTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.FaxNumberTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.faxNumber'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="FaxNumberTextFiled"
                          name="FaxNumberTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.EvacuationTypeSelectBox ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.evacuationType'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="EvacuationTypeSelectBox"
                          name="EvacuationTypeSelectBox"
                          component={Render.selectBox}
                          className={classes.text}
                          options={[
                            {key: "避難者", value: "避難者"},
                            {key: "在宅避難者", value: "在宅避難者"},
                            {key: "帰宅困難者", value: "帰宅困難者"},
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.TransportationSelectBox ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.transportation'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="TransportationSelectBox"
                          name="TransportationSelectBox"
                          component={Render.selectBox}
                          className={classes.text}
                          options={[
                            {key: "徒歩", value: "徒歩"},
                            {key: "自転車", value: "自転車"},
                            {key: "バイク", value: "バイク"},
                            {key: "自動車", value: "自動車"},
                            {key: "その他", value: "その他"},
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.OtherTransportationTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.otherTransportation'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="OtherTransportationTextFiled"
                          name="OtherTransportationTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.CarsTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.cars'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="CarsTextFiled"
                          name="CarsTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textWidth100}
                          placeholder="(例)123"
                          validate={[
                            (v) => Validator.typeNumber(v),
                            (v) => Validator.maxLength(v,12),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.CarModelTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.carModel'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="CarModelTextFiled"
                          name="CarModelTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.CarColorTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.carColor'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="CarColorTextFiled"
                          name="CarColorTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.CarNumberPlateTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.carNumberPlate'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="CarNumberPlateTextFiled"
                          name="CarNumberPlateTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.ParkingTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.parking'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="ParkingTextFiled"
                          name="ParkingTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.PetSelectBox ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.pet'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="PetSelectBox"
                          name="PetSelectBox"
                          component={Render.selectBox}
                          className={classes.text}
                          options={[
                            {key: "いる", value: "いる"},
                            {key: "いない", value: "いない"},
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.PetStateSelectBox ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.petState'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="PetStateSelectBox"
                          name="PetStateSelectBox"
                          component={Render.selectBox}
                          className={classes.text}
                          options={[
                            {key: "同伴希望", value: "同伴希望"},
                            {key: "置き去り", value: "置き去り"},
                            {key: "行方不明", value: "行方不明"},
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.HouseDamageSelectBox ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.houseDamage'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="HouseDamageSelectBox"
                          name="HouseDamageSelectBox"
                          component={Render.selectBox}
                          className={classes.text}
                          
                          options={[
                            {key: "被害なし", value: "被害なし"},
                            {key: "全壊", value: "全壊"},
                            {key: "半壊", value: "半壊"},
                            {key: "一部損壊", value: "一部損壊"},
                            {key: "全焼", value: "全焼"},
                            {key: "半焼", value: "半焼"},
                            {key: "床上浸水", value: "床上浸水"},
                            {key: "床下浸水", value: "床下浸水"},
                            {key: "流出", value: "流出"},
                            {key: "その他", value: "その他"},
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.InfraDamageSelectBox ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.infraDamage'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Select
                          id="InfraDamageSelectBox"
                          name="InfraDamageSelectBox"
                          className={classes.selectMultiple}
                          multiple
                          value={this.state.infraDamage}
                          onChange={(e) => {
                                  let ret = [];
                                  if(e.target.value) {
                                    ret=e.target.value;
                                  }
                                  this.setState({infraDamage:ret});
                                }}
                          renderValue={(selected) => selected.join(', ')}
                          MenuProps = {{
                              variant: 'menu',
                          }}
                        >
                        <MenuItem value={'被害なし'}> 被害なし</MenuItem>
                        <MenuItem value={'断水'}> 断水</MenuItem>
                        <MenuItem value={'停電'}> 停電</MenuItem>
                        <MenuItem value={'ガス停止'}> ガス停止</MenuItem>
                        <MenuItem value={'電話不通'}> 電話不通</MenuItem>
                        <MenuItem value={'その他'}> その他</MenuItem>
                        </Select>
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.OtherDamageTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.otherDamage'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="OtherDamageTextFiled"
                          name="OtherDamageTextFiled"
                          component={Render.textFieldMax100}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,100),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.CitizenSelectBox ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.citizen'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="CitizenSelectBox"
                          name="CitizenSelectBox"
                          component={Render.selectBox}
                          className={classes.text}
                          options={[
                            {key: "市民", value: "市民"},
                            {key: "それ以外", value: "それ以外"},
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.Spare1RTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <span>
                        {this.props.displayName.spare1R}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="Spare1RTextFiled"
                          name="Spare1RTextFiled"
                          component={Render.textFieldMax100}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,100),
                          ]}
                        />
                        
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.Spare2RTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <span>
                        {this.props.displayName.spare2R}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="Spare2RTextFiled"
                          name="Spare2RTextFiled"
                          component={Render.textFieldMax100}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,100),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.Spare3RTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <span>
                        {this.props.displayName.spare3R}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="Spare3RTextFiled"
                          name="Spare3RTextFiled"
                          component={Render.textFieldMax100}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,100),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.Spare4RTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <span>
                        {this.props.displayName.spare4R}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="Spare4RTextFiled"
                          name="Spare4RTextFiled"
                          component={Render.selectBox}
                          className={classes.text}
                          options={[
                            {key: "予備（代表）４ー１", value: "予備（代表）４ー１"},
                            {key: "予備（代表）４ー２", value: "予備（代表）４ー２"},
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.Spare5RTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <span>
                        {this.props.displayName.spare5R}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="Spare5RTextFiled"
                          name="Spare5RTextFiled"
                          component={Render.selectBox}
                          className={classes.text}
                          options={[
                            {key: "予備（代表）５ー１", value: "予備（代表）５ー１"},
                            {key: "予備（代表）５ー２", value: "予備（代表）５ー２"},
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
              </DialogContent>
              
              <DialogActions>
                <Button
                  id="btnSave"
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  size="large"
                  onClick={handleSubmit(this.doSetSetaiInfo)}
                >  
                  <span>登録</span>
                </Button>
                <Button
                  id="btnCancel"
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  size="large"
                  onClick={this.handleSetaiClose}
                >  
                  <span>キャンセル</span>
                </Button>
              </DialogActions>
            </React.Fragment>
          </Dialog>
              
              
              
          <Dialog
            open={this.state.isKojinDialog}
            onClose={(event, reason) =>
                       {if (reason !== 'backdropClick') {this.handleClose()}}}
            fullWidth={true}
            maxWidth="xl"
            scroll="paper"
            aria-labelledby="scroll-dialog-title"
          >
            <React.Fragment>
              <DialogTitle>
              個人情報登録
                <IconButton className={classes.closeButton} onClick={this.handleClose}>
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                <Grid container item xs={12} sm={12} >
                  {this.props.showHide.PersonalNameTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.personalName'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="PersonalNameTextFiled"
                          name="PersonalNameTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v,a) => Validator.checkPersonalName(v,a),
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.PersonalHiraTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.personalHira'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="PersonalHiraTextFiled"
                          name="PersonalHiraTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.PersonalKanaTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.personalKana'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="PersonalKanaTextFiled"
                          name="PersonalKanaTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.GenderSelectBox ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.gender'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="GenderSelectBox"
                          name="GenderSelectBox"
                          component={Render.selectBox}
                          className={classes.text}
                          options={[
                            {key: "男", value: "男"},
                            {key: "女", value: "女"},
                            {key: "その他", value: "その他"},
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.BirthDateYearSelectBox ? 
                    <Grid className={classes.modalRow2} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.birthDate'} />
                      </Grid>
                      <Grid item xs={12} sm={12} className={classes.modalRow} >
                        <Field
                          id="BirthDateYearSelectBox"
                          name="BirthDateYearSelectBox"
                          component={Render.selectBox}
                          className={classes.textWidth230}
                          options={this.props.yearList}
                          validate={[
                            (v,a) => Validator.checkDateOfBirth(v,a),
                          ]}
                        />
                        <FormattedMessage id={'infoadd.label.birthDateYear'} />
                      </Grid>
                      <Grid item xs={12} sm={12} className={classes.modalRow} >
                        <Field
                          id="BirthDateMonthSelectBox"
                          name="BirthDateMonthSelectBox"
                          component={Render.selectBox}
                          className={classes.textWidth80}
                          options={[
                            {key: "1", value: "1"},
                            {key: "2", value: "2"},
                            {key: "3", value: "3"},
                            {key: "4", value: "4"},
                            {key: "5", value: "5"},
                            {key: "6", value: "6"},
                            {key: "7", value: "7"},
                            {key: "8", value: "8"},
                            {key: "9", value: "9"},
                            {key: "10", value: "10"},
                            {key: "11", value: "11"},
                            {key: "12", value: "12"},
                          ]}
                        />
                      <FormattedMessage id={'infoadd.label.birthDateMonth'} />
                      </Grid>
                      <Grid item xs={12} sm={12} className={classes.modalRow} >
                        <Field
                          id="BirthDateDaySelectBox"
                          name="BirthDateDaySelectBox"
                          component={Render.selectBox}
                          className={classes.textWidth80}
                          options={[
                            {key: "1", value: "1"},
                            {key: "2", value: "2"},
                            {key: "3", value: "3"},
                            {key: "4", value: "4"},
                            {key: "5", value: "5"},
                            {key: "6", value: "6"},
                            {key: "7", value: "7"},
                            {key: "8", value: "8"},
                            {key: "9", value: "9"},
                            {key: "10", value: "10"},
                            {key: "11", value: "11"},
                            {key: "12", value: "12"},
                            {key: "13", value: "13"},
                            {key: "14", value: "14"},
                            {key: "15", value: "15"},
                            {key: "16", value: "16"},
                            {key: "17", value: "17"},
                            {key: "18", value: "18"},
                            {key: "19", value: "19"},
                            {key: "20", value: "20"},
                            {key: "21", value: "21"},
                            {key: "22", value: "22"},
                            {key: "23", value: "23"},
                            {key: "24", value: "24"},
                            {key: "25", value: "25"},
                            {key: "26", value: "26"},
                            {key: "27", value: "27"},
                            {key: "28", value: "28"},
                            {key: "29", value: "29"},
                            {key: "30", value: "30"},
                            {key: "31", value: "31"},
                          ]}
                        />
                        <FormattedMessage id={'infoadd.label.birthDateDay'} />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.AgeTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.age'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="AgeTextFiled"
                          name="AgeTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textWidth100}
                          placeholder="(例)123"
                          validate={[
                            (v) => Validator.typeNumber(v),
                            (v) => Validator.maxLength(v,12),
                          ]}
                        />
                        <FormattedMessage id={'infoadd.label.age2'} />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.TelephoneNumberTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.telephoneNumber'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="TelephoneNumberTextFiled"
                          name="TelephoneNumberTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                        />
                      </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.RelationshipTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.relationship'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="RelationshipTextFiled"
                          name="RelationshipTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.NationalitySelectBox ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.nationality'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="NationalitySelectBox"
                          name="NationalitySelectBox"
                          component={Render.selectBox}
                          className={classes.text}
                          options={[
                            {key: "日本", value: "日本"},
                            {key: "その他", value: "その他"},
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.OtherNationalityTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.otherNationality'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="OtherNationalityTextFiled"
                          name="OtherNationalityTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.LanguageTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.language'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="LanguageTextFiled"
                          name="LanguageTextFiled"
                          component={Render.textFieldMax100}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,100),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.EvacuationFormSelectBox ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.evacuationForm'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="EvacuationFormSelectBox"
                          name="EvacuationFormSelectBox"
                          component={Render.selectBox}
                          className={classes.text}
                          options={[
                            {key: "避難所", value: "避難所"},
                            {key: "テント", value: "テント"},
                            {key: "車中", value: "車中"},
                            {key: "その他", value: "その他"},
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.OtherEvacuationFormTextFiled ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.otherEvacuationForm'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="OtherEvacuationFormTextFiled"
                          name="OtherEvacuationFormTextFiled"
                          component={Render.textFieldMax50}
                          className={classes.textField}
                          validate={[
                            (v) => Validator.maxLength(v,50),
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.PlaceSelectBox ? 
                    <Grid className={classes.modalRow} >
                      <Grid item xs={12} sm={12} >
                        <FormattedMessage id={'infoadd.label.place'} />
                      </Grid>
                      <Grid item xs={12} sm={12} >
                        <Field
                          id="PlaceSelectBox"
                          name="PlaceSelectBox"
                          component={Render.selectBox}
                          className={classes.text}
                          options={[
                            {key: "避難所", value: "避難所"},
                            {key: "テント（敷地内）", value: "テント（敷地内）"},
                            {key: "車両（敷地内駐車）", value: "車両（敷地内駐車）"},
                            {key: "避難所以外の場所（自宅）", value: "避難所以外の場所（自宅）"},
                            {key: "その他", value: "その他"},
                          ]}
                        />
                      </Grid>
                    </Grid>
                  :""
                  }
                  {this.props.showHide.OtherPlaceTextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.otherPlace'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="OtherPlaceTextFiled"
                        name="OtherPlaceTextFiled"
                        component={Render.textFieldMax50}
                        className={classes.textField}
                        validate={[
                          (v) => Validator.maxLength(v,50),
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.FoodsSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.foods'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="FoodsSelectBox"
                        name="FoodsSelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "不要", value: "不要"},
                          {key: "普通食", value: "普通食"},
                          {key: "おかゆ", value: "おかゆ"},
                          {key: "離乳食", value: "離乳食"},
                          {key: "ミルク", value: "ミルク"},
                          {key: "その他", value: "その他"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.OtherFoodsTextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.otherFoods'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="OtherFoodsTextFiled"
                        name="OtherFoodsTextFiled"
                        component={Render.textFieldMax100}
                        className={classes.textField}
                        validate={[
                          (v) => Validator.maxLength(v,100),
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.DiseaseTextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.disease'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="DiseaseTextFiled"
                        name="DiseaseTextFiled"
                        component={Render.textFieldMax100}
                        className={classes.textField}
                        validate={[
                          (v) => Validator.maxLength(v,100),
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.InjuryTextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.injury'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="InjuryTextFiled"
                        name="InjuryTextFiled"
                        component={Render.textFieldMax100}
                        className={classes.textField}
                        validate={[
                          (v) => Validator.maxLength(v,100),
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.ShoniIryoSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.shoniIryo'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="ShoniIryoSelectBox"
                        name="ShoniIryoSelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "該当", value: "該当"},
                          {key: "非該当", value: "非該当"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.JinkoTosekiSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.jinkoToseki'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="JinkoTosekiSelectBox"
                        name="JinkoTosekiSelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "該当", value: "該当"},
                          {key: "非該当", value: "非該当"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.SansoRyohoSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.sansoRyoho'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="SansoRyohoSelectBox"
                        name="SansoRyohoSelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "該当", value: "該当"},
                          {key: "非該当", value: "非該当"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.FujinkaIryoSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.fujinkaIryo'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="FujinkaIryoSelectBox"
                        name="FujinkaIryoSelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "該当", value: "該当"},
                          {key: "非該当", value: "非該当"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.SeishinIryoSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.seishinIryo'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="SeishinIryoSelectBox"
                        name="SeishinIryoSelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "該当", value: "該当"},
                          {key: "非該当", value: "非該当"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.FeverCoughSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.feverCough'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="FeverCoughSelectBox"
                        name="FeverCoughSelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "あり", value: "あり"},
                          {key: "なし", value: "なし"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.KaigoTextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.kaigo'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="KaigoTextFiled"
                        name="KaigoTextFiled"
                        component={Render.textFieldMax50}
                        className={classes.textField}
                        validate={[
                          (v) => Validator.maxLength(v,50),
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.DeficiencySelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.deficiency'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="DeficiencySelectBox"
                        name="DeficiencySelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "あり", value: "あり"},
                          {key: "なし", value: "なし"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.RiskSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.risk'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="RiskSelectBox"
                        name="RiskSelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "あり", value: "あり"},
                          {key: "なし", value: "なし"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.BloodTypeSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.bloodType'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="BloodTypeSelectBox"
                        name="BloodTypeSelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "A型", value: "A型"},
                          {key: "B型", value: "B型"},
                          {key: "O型", value: "O型"},
                          {key: "AB型", value: "AB型"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.MedicineSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.medicine'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="MedicineSelectBox"
                        name="MedicineSelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "あり", value: "あり"},
                          {key: "なし", value: "なし"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.MedicineTextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.medicineName'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="MedicineTextFiled"
                        name="MedicineTextFiled"
                        component={Render.textFieldMax100}
                        className={classes.textField}
                        validate={[
                          (v) => Validator.maxLength(v,100),
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.AllergyTextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.allergy'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="AllergyTextFiled"
                        name="AllergyTextFiled"
                        component={Render.textFieldMax100}
                        className={classes.textField}
                        validate={[
                          (v) => Validator.maxLength(v,100),
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.DisabledTextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.disabled'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="DisabledTextFiled"
                        name="DisabledTextFiled"
                        component={Render.textFieldMax50}
                        className={classes.textField}
                        validate={[
                          (v) => Validator.maxLength(v,50),
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.IryokikiSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.iryokiki'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="IryokikiSelectBox"
                        name="IryokikiSelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "該当", value: "該当"},
                          {key: "非該当", value: "非該当"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.PregnancySelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.pregnancy'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="PregnancySelectBox"
                        name="PregnancySelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "該当", value: "該当"},
                          {key: "非該当", value: "非該当"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.ChildSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.child'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="ChildSelectBox"
                        name="ChildSelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "該当", value: "該当"},
                          {key: "非該当", value: "非該当"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.RequestTextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.request'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="RequestTextFiled"
                        name="RequestTextFiled"
                        component={Render.textFieldMax100}
                        className={classes.textField}
                        validate={[
                          (v) => Validator.maxLength(v,100),
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.CooperationSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.cooperation'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Select
                        id="CooperationSelectBox"
                        name="CooperationSelectBox"
                        className={classes.selectMultiple}
                        multiple
                        value={this.state.cooperation}
                        onChange={(e) => {
                                let ret = [];
                                if(e.target.value) {
                                  ret=e.target.value;
                                }
                                this.setState({cooperation:ret});
                              }}
                        renderValue={(selected) => selected.join(', ')}
                        MenuProps = {{
                            variant: 'menu',
                        }}
                      >
                      <MenuItem value={'なし'}> なし</MenuItem>
                      <MenuItem value={'けがの手当て'}> けがの手当て</MenuItem>
                      <MenuItem value={'子供の世話'}> 子供の世話</MenuItem>
                      <MenuItem value={'介護'}> 介護</MenuItem>
                      <MenuItem value={'炊事・洗濯'}> 炊事・洗濯</MenuItem>
                      <MenuItem value={'大工・力仕事'}> 大工・力仕事</MenuItem>
                      <MenuItem value={'建物設備点検'}> 建物設備点検</MenuItem>
                      </Select>
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.OtherCooperationTextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.otherCooperation'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="OtherCooperationTextFiled"
                        name="OtherCooperationTextFiled"
                        component={Render.textFieldMax100}
                        className={classes.textField}
                        validate={[
                          (v) => Validator.maxLength(v,100),
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.FreeTextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.free'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="FreeTextFiled"
                        name="FreeTextFiled"
                        component={Render.textFieldMax100}
                        className={classes.textField}
                        validate={[
                          (v) => Validator.maxLength(v,100),
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.InformationSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.information'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="InformationSelectBox"
                        name="InformationSelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "可", value: "可"},
                          {key: "否", value: "否"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.DisclosureSelectBox ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <FormattedMessage id={'infoadd.label.disclosure'} />
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="DisclosureSelectBox"
                        name="DisclosureSelectBox"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "可", value: "可"},
                          {key: "否", value: "否"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.Spare1TextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <span>
                      {this.props.displayName.spare1}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="Spare1TextFiled"
                        name="Spare1TextFiled"
                        component={Render.textFieldMax100}
                        className={classes.textField}
                        validate={[
                          (v) => Validator.maxLength(v,100),
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.Spare2TextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <span>
                      {this.props.displayName.spare2}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="Spare2TextFiled"
                        name="Spare2TextFiled"
                        component={Render.textFieldMax100}
                        className={classes.textField}
                        validate={[
                          (v) => Validator.maxLength(v,100),
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.Spare3TextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <span>
                      {this.props.displayName.spare3}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="Spare3TextFiled"
                        name="Spare3TextFiled"
                        component={Render.textFieldMax100}
                        className={classes.textField}
                        validate={[
                          (v) => Validator.maxLength(v,100),
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.Spare4TextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <span>
                      {this.props.displayName.spare4}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="Spare4TextFiled"
                        name="Spare4TextFiled"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "予備４－１", value: "予備４－１"},
                          {key: "予備４－２", value: "予備４－２"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                  {this.props.showHide.Spare5TextFiled ? 
                  <Grid className={classes.modalRow} >
                    <Grid item xs={12} sm={12} >
                      <span>
                      {this.props.displayName.spare5}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={12} >
                      <Field
                        id="Spare5TextFiled"
                        name="Spare5TextFiled"
                        component={Render.selectBox}
                        className={classes.text}
                        options={[
                          {key: "予備５－１", value: "予備５－１"},
                          {key: "予備５－２", value: "予備５－２"},
                        ]}
                      />
                    </Grid>
                  </Grid>
                  :""
                  }
                </Grid>
              
              </DialogContent>
              
              <DialogActions>
                <Button
                  id="btnSave"
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  size="large"
                  onClick={handleSubmit(this.doSetKojinInfolist)}
                >  
                  <span>登録</span>
                </Button>
                <Button
                  id="btnCancel"
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  size="large"
                  onClick={this.handleClose}
                >  
                  <span>キャンセル</span>
                </Button>
              </DialogActions>
            </React.Fragment>
          </Dialog>
          
        </Grid>
      </div>
    );
  }
}

const FORM_NAME = "Infoadd";

const mapStateToProps = state => ({
  initialValues:{
    DistrictNameTextFiled:"",
    ChonaikaiNameTextFiled:"",
    JichikaiNameTextFiled:"",
    AddressTextFiled:"",
    PersonalNameECTextFiled:"",
    AddressECTextFiled:"",
    NumberECTextFiled:"",
    RelationshipECTextFiled:"",
    RepresentativeNameTextFiled:"",
    RepresentativeHiraTextFiled:"",
    RepresentativeKanaTextFiled:"",
    EntryNameTextFiled:"",
    EntryHiraTextFiled:"",
    EntryKanaTextFiled:"",
    HomePhoneNumberTextFiled:"",
    FaxNumberTextFiled:"",
    EvacuationTypeSelectBox:"",
    TransportationSelectBox:"",
    OtherTransportationTextFiled:"",
    CarsTextFiled:"",
    CarModelTextFiled:"",
    CarColorTextFiled:"",
    CarNumberPlateTextFiled:"",
    ParkingTextFiled:"",
    PetSelectBox:"",
    PetStateSelectBox:"",
    HouseDamageSelectBox:"",
    InfraDamageSelectBox:[],
    OtherDamageTextFiled:"",
    CitizenSelectBox:"",
    Spare1RTextFiled:"",
    Spare2RTextFiled:"",
    Spare3RTextFiled:"",
    Spare4RTextFiled:"",
    Spare5RTextFiled:"",
    PersonalNameTextFiled:"",
    PersonalHiraTextFiled:"",
    PersonalKanaTextFiled:"",
    GenderSelectBox:"",
    BirthDateYearSelectBox:"",
    BirthDateMonthSelectBox:"",
    BirthDateDaySelectBox:"",
    AgeTextFiled:"",
    TelephoneNumberTextFiled:"",
    RelationshipTextFiled:"",
    NationalitySelectBox:"",
    OtherNationalityTextFiled:"",
    LanguageTextFiled:"",
    EvacuationFormSelectBox:"",
    OtherEvacuationFormTextFiled:"",
    PlaceSelectBox:"",
    OtherPlaceTextFiled:"",
    FoodsSelectBox:"",
    OtherFoodsTextFiled:"",
    DiseaseTextFiled:"",
    InjuryTextFiled:"",
    ShoniIryoSelectBox:"",
    JinkoTosekiSelectBox:"",
    SansoRyohoSelectBox:"",
    FujinkaIryoSelectBox:"",
    SeishinIryoSelectBox:"",
    FeverCoughSelectBox:"",
    KaigoTextFiled:"",
    DeficiencySelectBox:"",
    RiskSelectBox:"",
    BloodTypeSelectBox:"",
    MedicineSelectBox:"",
    MedicineTextFiled:"",
    AllergyTextFiled:"",
    DisabledTextFiled:"",
    IryokikiSelectBox:"",
    PregnancySelectBox:"",
    ChildSelectBox:"",
    RequestTextFiled:"",
    CooperationSelectBox:[],
    OtherCooperationTextFiled:"",
    FreeTextFiled:"",
    InformationSelectBox:"",
    DisclosureSelectBox:"",
    Spare1TextFiled:"",
    Spare2TextFiled:"",
    Spare3TextFiled:"",
    Spare4TextFiled:"",
    Spare5TextFiled:"",
  },
  values: getFormValues(FORM_NAME)(state),
  kojinInfo: state.infoadd.kojinInfo,
  setaiInfo: state.infoadd.setaiInfo,
  shelterName: state.infoaddSelect.shelterName,
  kojinInfoDetail: state.infoadd.kojinInfoDetail,
  yearList: state.infoadd.yearList,
  entryKubun: state.infoaddSelect.entryKubun,
  showHide:setting.showHide,
  displayName:setting.displayName
});

const mapDispatchToProps = {
};

Infoadd = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect(state => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Infoadd));

Infoadd.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Infoadd));